import React, { useState } from "react";
import SummaryApi from "../common";
import Swal from "sweetalert2";

const CreateServices = () => {
  const [serviceName, setServiceName] = useState("");
  const [servicePrice, setServicePrice] = useState("");
  const [serviceDesc, setServiceDesc] = useState("");
  const [serviceImg, setServiceImg] = useState(null);
  const [isActive, setIsActive] = useState(true);

  const resetForm = () => {
    setServiceName("");
    setServicePrice("");
    setServiceDesc("");
    setServiceImg(null);
    setIsActive(true);

    // reset file input manually because it's uncontrolled
    document.getElementById("serviceImgInput").value = "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("service_name", serviceName);
    formData.append("service_price", servicePrice);
    formData.append("service_desc", serviceDesc);
    formData.append("service_img", serviceImg);
    formData.append("is_active", isActive ? "1" : "0");

    try {
      const response = await fetch(SummaryApi.createServices.url, {
        method: "POST",
        body: formData
      });

      const result = await response.json();
      console.log(result);

      Swal.fire({
        icon: "success",
        title: "Service Created",
        text: "Your service has been added successfully!",
        timer: 2000,
        showConfirmButton: false
      });

      resetForm();
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while creating the service."
      });
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white shadow-md rounded-lg mt-6">
      <h2 className="text-xl font-semibold mb-4">Create Service</h2>

      <form onSubmit={handleSubmit} className="space-y-4">

        <div>
          <label className="block font-medium mb-1">Service Name</label>
          <input
            type="text"
            className="w-full border p-2 rounded"
            value={serviceName}
            onChange={(e) => setServiceName(e.target.value)}
            required
          />
        </div>

        <div>
          <label className="block font-medium mb-1">Service Price</label>
          <input
            type="number"
            step="0.01"
            className="w-full border p-2 rounded"
            value={servicePrice}
            onChange={(e) => setServicePrice(e.target.value)}
            required
          />
        </div>

        <div>
          <label className="block font-medium mb-1">Description</label>
          <textarea
            className="w-full border p-2 rounded"
            value={serviceDesc}
            onChange={(e) => setServiceDesc(e.target.value)}
            required
          />
        </div>

        <div>
          <label className="block font-medium mb-1">Service Image</label>
          <input
            id="serviceImgInput"
            type="file"
            accept="image/*"
            className="w-full"
            onChange={(e) => setServiceImg(e.target.files[0])}
            required
          />
        </div>

        <div className="flex items-center gap-3">
          <span className="font-medium">Active?</span>

          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={isActive}
              onChange={() => setIsActive(!isActive)}
            />
            <div className="w-11 h-6 bg-gray-300 peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:bg-green-500 transition-all"></div>
            <span className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-all peer-checked:translate-x-5"></span>
          </label>
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded"
        >
          Create Service
        </button>
      </form>
    </div>
  );
};

export default CreateServices;
